'use client';

import Script from 'next/script';
import { GA_ID } from '@/lib/site';

/**
 * Renders nothing unless a real GA id is configured. See GA_ID in lib/site:
 * the builder commits a placeholder that is truthy, so the usual
 * `env || fallback` guard loads a tag for a property that does not exist.
 */
export default function Analytics() {
  if (!GA_ID) return null;
  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`}
        strategy="afterInteractive"
      />
      <Script id="ga-init" strategy="afterInteractive">
        {`window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}
gtag('js',new Date());gtag('config','${GA_ID}');`}
      </Script>
    </>
  );
}
